<template>
  <v-flex xs12 row>
  	<v-layout row wrap>
  		<v-flex xs12>
  			
  		</v-flex>
  	</v-layout>

	<v-layout py-3>
   		<v-flex xs12 md8 offset-md2>
   			<v-card>
	   			<v-card-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="400px" v-if="hasCreateAccess">
              <v-btn slot="activator" round color="primary" dark small class="ml-4">Add New</v-btn>
              <v-form v-model="validForm">
                <v-card>
                  <v-card-title>
                    <span class="headline" v-text="item.id ? 'Update Panchayath' : 'Add Panchayath'"></span>
                  </v-card-title>

                  <v-card-text>
                    <v-container grid-list-md py-0>
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-text-field v-model="item.panchayath" label="Panchayath" :rules="rules" counter="50"></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-autocomplete :rules="requireRule" v-model="item.country" :items="countries" item-text="country" item-value="id" label="Country"></v-autocomplete>
                        </v-flex>
                        <v-flex xs12>
                          <v-autocomplete :rules="requireRule" v-model="item.state" :items="states" item-text="state" item-value="id" label="State"></v-autocomplete>
                        </v-flex>
                        <v-flex xs12>
                          <v-autocomplete :rules="requireRule" v-model="item.district" :items="districts" item-text="district" item-value="id" label="District"></v-autocomplete>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat :disabled="processing" @click.native="close">Cancel</v-btn>
                    <v-btn color="blue darken-1" flat :disabled="!validForm || processing" :loading="processing" @click.native="item.id ? updateItem() : addItem()" v-text="item.id ? 'Update' : 'Save'"></v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-dialog>

			    </v-card-title>
	   			<v-data-table
				    :headers="headers"
				    :loading="processing"
				    :items="panchayaths"
				    item-key="id"
				    hide-actions
            disable-initial-sort
				  >
				  	<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
				    <template slot="headerCell" slot-scope="props">
				      <v-tooltip bottom>
				        <span slot="activator">
				          {{ props.header.text }}
				        </span>
				        <span>
				          {{ props.header.text }}
				        </span>
				      </v-tooltip>
				    </template>
				    <template slot="items" slot-scope="props">
              <td>{{ props.item.panchayath }}</td>
              <td>{{ props.item.district_name }}</td>
              <td>{{ props.item.state_name }}</td>
				      <td>{{ props.item.country_name }}</td>
              <td class="align-center justify-center layout px-0">
                <edit-btn :item="props.item" />
                <delete-btn :item="props.item" />
              </td>
				    </template>
				    <template slot="no-data" v-if="!processing && !panchayaths.length">
				      <v-alert :value="true" color="error" icon="warning">
				        Sorry, nothing to display here :(
				      </v-alert>
				    </template>
				  </v-data-table>

          <v-pagination @loadPage="loadPage" />

          <action-dialog action="delete" :status="deleteDialog" @close="closeDeleteDialog" @success="deleteItem(panchayaths)" />

			</v-card>
   		</v-flex>
   	</v-layout>
    
  </v-flex>
</template>

<script>

  export default {
    name: 'Panchayaths',
    data () {
      return {
        model: 'panchayath',
      	title: "Panchayaths",
        validForm: false,
      	processing: false,
        dialog: false,
        deleteDialog: false,
        states: [],
        districts: [],
      	panchayaths: [],
        headers: [
          { text: 'Panchayath', value: 'panchayath'},
          { text: 'District', value: 'district_name'},
          { text: 'State', value: 'state_name'},
          { text: 'Country', value: 'country_name'},
          { text: 'Actions', value: 'id', sortable: false }
        ],
        item: {},
        defaultItem: {
          id: "",
          panchayath: "",
          district: "",
          state: "",
          country: this.getDefault('country'),
          is_deleted: false
        },
        deletingItem: null,
        rules: [
          v => !!v || 'Panchayath name is required',
          v => v && v.length >= 3 || 'Must be more than 2 characters',
          v => v && v.length <= 50 || 'Maximum 50 characters allowed'
        ],
        requireRule: [
          v => !!v || 'Field is required'
        ]
      }
    },
    created () {
      	let breadcrumbs = [
	      	{
	          text: 'Dashboard',
	          disabled: false,
	          href: '/dashboard'
	        },
	        {
	          text: 'Panchayaths',
	          disabled: true
	        },
	        {
	          text: 'View',
	          disabled: true
	        }
       ]

      this.$store.commit('setBreadcrumbs', breadcrumbs)
      this.$store.commit('setPageTitle', 'Manage Panchayaths')
    },
    methods: {

      loadPage () {
        this.processing = true
        this.axios.get(this.config.apis.getPanchayaths.replace(":page", this.currentPage).replace(":perPage", this.paginationOptions.rowsPerPage))
          .then((response) => {
            this.processing = false
            if (response && response.data && response.data.success && response.data.data && response.data.data.items) {
            	this.panchayaths = response.data.data.items
              this.$store.commit('setItemsCount', response.data.data.total)
            }
            else{
            	this.panchayaths = []
              this.$store.commit('setItemsCount', 0)
            }
          })
          .catch((error) => {
            this.processing = false
          })
      },

      getDistricts (state) {
        this.processing = true
        this.districts = []
        this.axios.get(this.config.apis.getDistrictsByState.replace(":state", state))
        .then((response) => {
            this.processing = false
            if (this.isSuccessResponse(response)) {
              this.districts = response.data.data
            }
        })
        .catch((error) => {
            this.processing = false
        })
      },
      addItem () {
        this.processing = true
        this.axios.post(this.config.apis.addPanchayath, this.item)
          .then((response) => {
            if (this.isSuccessResponse(response)) {
              
              let new_item = Object.assign({}, this.item)
              new_item.id = response.data.data.id

              let country = this.countries.filter( v => v.id == new_item.country )

              new_item.country_name = country ? country[0].country : ""

              let state = this.states.filter( v => v.id == new_item.state )

              new_item.state_name = state ? state[0].state : ""

              let district = this.districts.filter( v => v.id == new_item.district )

              new_item.district_name = district ? district[0].district : ""

              this.panchayaths.unshift(new_item)

              this.notifySuccess('insertSuccess')
              this.close()
            }
            else{
              this.notifyError('insertError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
          })
      },
      updateItem () {
      	this.processing = true
        this.axios.put(this.config.apis.updatePanchayath.replace(":id", this.item.id), this.item)
          .then((response) => {
            if (this.isSuccessResponse(response)) {

              let country = this.countries.filter( v => v.id == this.item.country )

              this.item.country_name = country ? country[0].country : ""

              let state = this.states.filter( v => v.id == this.item.state )

              this.item.state_name = state ? state[0].state : ""

              let district = this.districts.filter( v => v.id == this.item.district )

              this.item.district_name = district ? district[0].district : ""
              
              this.notifySuccess('updateSuccess')
              this.close()
            }
            else{
              this.notifyError('updateError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
          })
      },

      editItem (item) {
        this.item = item
        this.dialog = true
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.item = this.extend({}, this.defaultItem)
        }, 300)
      }

    },
    mounted () {
      this.getCountries()
      this.item = this.extend({}, this.defaultItem)
    },

    computed: {

    },

    watch: {

        'item.country': function(val, oldVal){
            if (val && val != oldVal) {
                this.getStatesByCountry(val).then( states => {
                  this.states = states
                })
            }
        },
        'item.state': function(val, oldVal){
            if (val && val != oldVal) {
                this.getDistricts(val)
            }
        }
    }

  }
</script>
